var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};

(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, require("katex")) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports","katex"], mod) :
  /*plain env*/ mod(null, (this.HyperMD.PreviewFeatureMath = this.HyperMD.PreviewFeatureMath || {}), katex);
})(function (require, exports, katex) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    katex = __importStar(katex);
    /**
     *
     * @param content the math expression
     * @param displayMode whether to be rendered in display mode
     */
    function parseMath(_a) {
        var content = _a.content, displayMode = _a.displayMode;
        if (!content) {
            return "";
        }
        try {
            return katex.renderToString(content, Object.assign({}, /*configs.katexConfig ||*/ {}, { displayMode: displayMode }));
        }
        catch (error) {
            return "<span style=\"color: #ee7f49; font-weight: 500;\">" + error.toString() + "</span>";
        }
    }
    exports.default = (function (md) {
        // @ts-ignore
        md.inline.ruler.before("escape", "math", function (state, silent) {
            var openTag = null;
            var closeTag = null;
            var displayMode = true;
            var inlineDelimiters = [["$", "$"]];
            var blockDelimiters = [["$$", "$$"]];
            for (var _i = 0, blockDelimiters_1 = blockDelimiters; _i < blockDelimiters_1.length; _i++) {
                var tagPair = blockDelimiters_1[_i];
                if (state.src.startsWith(tagPair[0], state.pos)) {
                    openTag = tagPair[0], closeTag = tagPair[1];
                    break;
                }
            }
            if (!openTag) {
                for (var _a = 0, inlineDelimiters_1 = inlineDelimiters; _a < inlineDelimiters_1.length; _a++) {
                    var tagPair = inlineDelimiters_1[_a];
                    if (state.src.startsWith(tagPair[0], state.pos)) {
                        openTag = tagPair[0], closeTag = tagPair[1];
                        displayMode = false;
                        break;
                    }
                }
            }
            if (!openTag) {
                return false; // not math
            }
            var content = null;
            var end = -1;
            var i = state.pos + openTag.length;
            while (i < state.src.length) {
                if (state.src.startsWith(closeTag, i)) {
                    end = i;
                    break;
                }
                else if (state.src[i] === "\\") {
                    i += 1;
                }
                i += 1;
            }
            if (end >= 0) {
                content = state.src.slice(state.pos + openTag.length, end);
            }
            else {
                return false;
            }
            if (content && !silent) {
                var token = state.push("math");
                token.content = content.trim();
                token.openTag = openTag;
                token.closeTag = closeTag;
                token.displayMode = displayMode;
                state.pos += content.length + openTag.length + closeTag.length;
                return true;
            }
            else {
                return false;
            }
        });
        md.renderer.rules.math = function (tokens, idx) {
            var content = tokens[idx] ? tokens[idx].content : null;
            return parseMath({
                content: content,
                displayMode: tokens[idx].displayMode
            });
        };
    });
});
